import React from 'react';
import { Button } from 'antd';
import { MouseEventHandler } from 'react';
import styles from './default-button.module.css';

const style = {
  primary: styles.primaryButton,
  default: styles.defaultButton,
  secondary: styles.secondaryButton,
  secondaryRed: styles.secondaryRedButton,
};

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  onClick?: MouseEventHandler<HTMLElement>;
  style?: React.CSSProperties | undefined;
  type?: 'primary' | 'secondary' | 'secondaryRed';
  disabled?: boolean;
};

const DefaultButton: React.FC<Props> = (props) => {
  return (
    <Button
      className={props.type ? style[props.type] : 'default'}
      icon={props.icon}
      onClick={props.onClick}
      style={props.style}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
};

export default DefaultButton;
